import { isMobile } from './device-utils';

export const tabScrollIntoView = (tab: Element, behavior: ScrollBehavior = 'smooth'): void => {
  if (isMobile() && tab && typeof tab.scrollIntoView === 'function') {
    tab.scrollIntoView({
      behavior,
      block: 'nearest',
      inline: 'center',
    });
  }
};
